import type { ColumnDef } from "@tanstack/react-table"

import { ProductStatusCell } from "@/components/table/ProductStatusCell"
import type { Product, QualityApproval } from "@/graphql/codegen/graphql"
import { InventoryProductDescription } from "@/screens/Inventory/components/InventoryProductDescription"

interface UseProductTestResultColumnsProps {
  isApprovalRequest: boolean
}

export const useProductTestResultColumns = ({
  isApprovalRequest,
}: UseProductTestResultColumnsProps): ColumnDef<QualityApproval>[] => [
  {
    accessorKey: "productId",
    header: "Product ID",
    cell: ({ row }) => <ProductStatusCell product={row.original.productTestResult?.productTest?.product as Product} />,
    enableSorting: true,
  },
  {
    accessorKey: "productDescription",
    header: "Description",
    cell: ({ row }) => (
      <InventoryProductDescription product={row.original.productTestResult?.productTest?.product as Product} />
    ),
    enableSorting: true,
  },
  {
    accessorKey: "supplier",
    header: "Supplier",
    cell: ({ row }) => row.original.productTestResult?.productTest?.product?.company?.name ?? null,
    enableSorting: isApprovalRequest,
  },
  {
    accessorKey: "lotNumber",
    header: "Lot #",
    cell: ({ row }) => row.original.productTestResult?.productTest?.lotNumber ?? null,
    enableSorting: false,
  },
  {
    accessorKey: "batchNumber",
    header: "Batch #",
    cell: ({ row }) => row.original.productTestResult?.productTest?.batchNumber ?? null,
    enableSorting: false,
  },
  {
    accessorKey: "testNumber",
    header: "Test #",
    cell: ({ row }) => row.original.productTestResult?.associatedTestTemplate?.testTemplate?.externalSystemId ?? null,
    enableSorting: false,
  },
  {
    accessorKey: "testDescription",
    header: "Description",
    cell: ({ row }) => row.original.productTestResult?.associatedTestTemplate?.testTemplate?.description ?? null,
    enableSorting: isApprovalRequest,
  },
]
